import { Box, makeStyles } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

export const useStyles = makeStyles((theme) => ({
  content: {
    backgroundColor: "#06293D",
  },
  textContent: {
    maxWidth: "1120px",
    margin: "auto",
  },
  text: {
    padding: "5px 20px",
    color: theme.palette.text.secondary,
    fontFamily: theme.typography.fontFamily,
    textAlign: "center",
    fontSize: 16,
    lineHeight: "17px",
    fontWeight: theme.typography.fontWeightMedium,
    [theme.breakpoints.up("sm")]: {
      padding: "5px 60px 7px 60px",
    },
  },
}));

const InfoBanner = (props) => {
  const classes = useStyles();

  return (
    <Box {...props} className={classes.content}>
      <Box className={classes.textContent}>
        <Box className={classes.text}>
          <FormattedMessage id="infoBanner.text" />
        </Box>
      </Box>
    </Box>
  );
};

export default InfoBanner;
